(function (angular) {
    'use strict';

    angular.module('branch')
        /**
         *
         */
        .controller('ruleCreationModalCtrl',
            ['$scope', 'rulesService', '$stateParams', '$uibModalInstance', 'growlService', 'channelsData', 'ruleData',
                function ($scope, rulesService, $stateParams, $uibModalInstance, growlService, channelsData, ruleData) {

                    var channels = channelsData;
                    $scope.allChannels = channelsData;
                    $scope.channels = [angular.copy(channels), []];
                    var previousChannels = angular.copy(ruleData.channels);
                    $scope.newRule = {};

                    if (ruleData) {
                        $scope.isNew = false;
                        $scope.newRule.name = ruleData.name;
                        $scope.newRule.channels = ruleData.channels;
                        
                    } else {
                        $scope.isNew = true;
                        $scope.newRule.name = '';
                        $scope.newRule.channels = [''];
                    }

                    $scope.cancel = function () {
                        ruleData.channels = previousChannels;
                        $uibModalInstance.dismiss('cancel');
                    };

                    $scope.hasDupes = function hasDupes(array) {
                        var dupes = _.filter(array, function (value, index, iteratee) {
                            return _.includes(iteratee, value, index + 1);
                        });
                        return dupes.length && dupes.length > 0;
                    };

                    $scope.ruleIsEmpty = function ruleIsEmpty() {
                        return _.includes($scope.newRule.channels, '');
                    };

                    $scope.create = function create() {
                        var data;
                        if ($scope.hasDupes($scope.newRule.channels)) {
                            return false;
                        }

                        if (ruleData) {
                            data = {
                                id: ruleData.id,
                                name: $scope.newRule.name,
                                channels: $scope.newRule.channels
                            };
                            rulesService.updateRule($stateParams.pickedApiSpaceId, data).then(function (result) {
                                growlService.success('Rule updated');
                                $uibModalInstance.close(result);

                            }).catch(function (error) {
                                growlService.danger("Rule wasn't updated due to: " + error.statusText);
                            });

                        } else {
                            data = {
                                name: $scope.newRule.name,
                                channels: $scope.newRule.channels
                            };

                            rulesService.createRule($stateParams.pickedApiSpaceId, data).then(function (result) {
                                growlService.success('Rule created');
                                $uibModalInstance.close(result);

                            }).catch(function (error) {
                                growlService.danger("Rule wasn't created due to: " + error.statusText);
                            });
                        }

                    };



                }]);


})(window.angular);
